export default __webpack_public_path__ + "904b0b34ad98307e8d0491013f5eb19c.png";